import { useEffect, useState } from "react";
import { captureUtm } from "@/components/AttendeeFields";

const GA_ID = process.env.REACT_APP_GA_ID;

const loadGA = () => {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem("mct_cookie_consent"));
  useEffect(() => {
    captureUtm();
    if (choice === "accepted") loadGA();
  }, [choice]);
  const decide = (v) => { localStorage.setItem("mct_cookie_consent", v); setChoice(v); };
  if (choice) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0B1B33] p-4 text-sm text-white shadow-2xl" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
        <p className="max-w-3xl">We use essential cookies to run this site. With your permission we also use analytics cookies (Google Analytics) to see which pages help people. <a href="/privacy" className="underline">Privacy Policy</a></p>
        <div className="flex gap-2">
          <button className="rounded-md border border-white/50 bg-transparent px-4 py-2 font-semibold text-white transition-colors hover:bg-white/10" onClick={() => decide("declined")} data-testid="cookie-decline-btn">Essential only</button>
          <button className="btn-gold" onClick={() => decide("accepted")} data-testid="cookie-accept-btn">Accept analytics</button>
        </div>
      </div>
    </div>
  );
};
